import Oops from '~/common/components/Oops';

import { StyledLoan1003LayoutContainer } from '../common/components/StyledComponents';
import { AssetsCrudGrid } from './components/AssetsCrudGrid';
import { ExcludedAssetsTable } from './components/ExcludedAssetsTable';
import TotalAssetInfoWindow from './components/TotalAssetInfoWindow';
import { AssetForm } from './forms/AssetForm';
import { ReservesForm } from './forms/ReservesForm';
import { SubordinateFinancingForm } from './forms/SubordinateFinancingForm';
import { useGetAssetsSummaryInformationQuery } from './hooks';
import { useAsset1003Store } from './store';

export function Assets1003() {
  const { isLoading, isError } = useGetAssetsSummaryInformationQuery();

  if (isError) {
    return <Oops />;
  }

  return (
    <StyledLoan1003LayoutContainer>
      {!isLoading && <TotalAssetInfoWindow />}
      <AssetsCrudGrid />
      {!isLoading && <Assets1003FormContainer />}
      {!isLoading && <ExcludedAssetsTable />}
    </StyledLoan1003LayoutContainer>
  );
}

function Assets1003FormContainer() {
  const activeForm = useAsset1003Store((s) => s.activeForm);

  if (!activeForm) {
    return null;
  }

  switch (activeForm.type) {
    case 'asset':
      return (
        <AssetForm key={activeForm.assetId} assetId={activeForm.assetId} />
      );
    case 'reserves':
      return <ReservesForm />;
    case 'subordinateFinancing':
      return <SubordinateFinancingForm />;
  }
}
